// Team K9 emergency 2026-06-19: temporarily disabled.
// The original localization module white-screened pages before DOMContentLoaded
// when the theme rendered no localization select. Restore from emergency snapshot
// after the selector markup/script contract is fixed.
window.__tk9LocalizationDisabled = true;
